// extracted by mini-css-extract-plugin
export var list = "FooterList-module--list--XyoHo";
export var title = "FooterList-module--title--3cCYo";
export var item = "FooterList-module--item--3O5jJ";
export var link = "FooterList-module--link--3y6HX";